// Shop order status labels and chip colours used across shop admin screens
export const STATUS_META = {
    pending_payment: { label: "Payment pending", color: "warning" },
    paid: { label: "Paid", color: "info" },
    confirmed: { label: "Confirmed", color: "info" },
    packed: { label: "Packed", color: "info" },
    shipped: { label: "Shipped", color: "primary" },
    in_transit: { label: "In transit", color: "primary" },
    out_for_delivery: { label: "Out for delivery", color: "secondary" },
    delivered: { label: "Delivered", color: "success" },
    failed: { label: "Delivery failed", color: "error" },
    rto: { label: "Returned (RTO)", color: "error" },
    cancelled: { label: "Cancelled", color: "default" },
};
